import React from "react";
import { ContractRepoPage } from "./ContractRepoPage";

export function LegacyRepoPage() {
  return <ContractRepoPage isLegacy={true} />;
}
 